import { render, staticRenderFns } from "./DarkNavLink.vue?vue&type=template&id=4fcee4da&scoped=true"
import script from "./DarkNavLink.vue?vue&type=script&lang=js"
export * from "./DarkNavLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcee4da",
  null
  
)

export default component.exports